import { render, staticRenderFns } from "./VCheckbox.vue?vue&type=template&id=8bda42ca"
import script from "./VCheckbox.vue?vue&type=script&lang=js"
export * from "./VCheckbox.vue?vue&type=script&lang=js"
import style0 from "./VCheckbox.vue?vue&type=style&index=0&id=8bda42ca&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8bda42ca')) {
      api.createRecord('8bda42ca', component.options)
    } else {
      api.reload('8bda42ca', component.options)
    }
    module.hot.accept("./VCheckbox.vue?vue&type=template&id=8bda42ca", function () {
      api.rerender('8bda42ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/controls/VCheckbox.vue"
export default component.exports